<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-start">
      <Breadcrumbs
        headline="Báo cáo tồn thời điểm"
        :link="[{ text: 'Báo cáo tồn thời điểm', href: '/inventory-time-report' }]"
      />
    </div>
    <FilterInventoryReport @onFilter="v => $refs.table.onFilter(v)" />
    <v-card outlined class="mx-4 mb-6 elevation-0">
      <TableInventoryTimeReport ref="table" type="inventoryTime"
    /></v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import FilterInventoryReport from './FilterInventoryReport.vue'
import TableInventoryTimeReport from './TableInventoryTimeReport.vue'
export default {
  components: {
    Breadcrumbs,
    FilterInventoryReport,
    TableInventoryTimeReport
  }
}
</script>
